<div class="maintenance-container" fxLayoutAlign="center center" fxFlexFill>
  <div class="background-container-1" fxLayoutAlign="center center">
    <div class="background-container-2" fxLayoutAlign="center center">
      <div class="background-container-3" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">

        <!-- Header -->
        <div class="header-container" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
          <h1 class="mat-h1 header">{{ isMaintenanceEnded ? 'MAINTENANCE.BACK_UP' : 'MAINTENANCE.DOWN' | translate }}</h1>
          <span class="subheader color-accent">{{ isMaintenanceEnded ? 'MAINTENANCE.SIGN_IN' : 'MAINTENANCE.SOON' | translate }}</span>
        </div>

        <!-- Maintenance Content -->
        <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px" *ngIf="!isMaintenanceEnded; else signInButton">
          <img src="assets/images/hamster-spinner.gif" height="193" width="193" alt="Hamster Spinner"/>
          <div class="postscript" fxLayout="column" fxLayoutAlign="start center">
            <span>{{ 'MAINTENANCE.THANK_YOU' | translate }}</span>
            <span>{{ 'MAINTENANCE.BEST' | translate }}</span>
            <br/>
            <span>{{ 'MAINTENANCE.NOTIFY' | translate }}</span>
          </div>
        </div>

        <!-- Sign In Button -->
        <ng-template #signInButton>
          <button mat-raised-button color="accent" (click)="signIn()">{{ 'MAINTENANCE.BUTTON' | translate }}</button>
        </ng-template>

      </div>
    </div>
  </div>
</div>
